import { useState } from 'react'
import { useSearch } from '@tanstack/react-router'
import { useSignup } from '@/api/hooks/auth.hooks'
import { usePasswordlessAuth } from './usePasswordlessAuth'
import { usePostAuthRedirect } from './usePostAuthRedirect'

export function useSignupViewModel() {
  const { redirect, email } = useSearch({ from: '/signup' })
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [acceptedTerms, setAcceptedTerms] = useState(false)
  const [emailMarketingConsent, setEmailMarketingConsent] = useState(false)

  const signup = useSignup()
  const onAuthenticated = usePostAuthRedirect(redirect)

  const auth = usePasswordlessAuth({
    // An `email` in the URL (from the login page's "no account" hand-off) only
    // prefills the field — signup still needs a name and the consent answers,
    // so it must not fire a request on mount the way /login does.
    initialEmail: email,
    autoRequestCode: false,
    // Signup emails the same 6-digit code, so the OTP step is shared as-is. The
    // account exists from here on, which is why resending falls back to
    // `passwordless/request` inside the hook rather than signing up again.
    requestCode: (signupEmail) =>
      signup.mutateAsync({
        email: signupEmail,
        firstName,
        lastName,
        acceptedTerms,
        emailMarketingConsent,
      }),
    isRequestingCode: signup.isPending,
    onSuccess: onAuthenticated,
  })

  return {
    ...auth,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    acceptedTerms,
    setAcceptedTerms,
    emailMarketingConsent,
    setEmailMarketingConsent,
    redirect,
  }
}
